if (!__DEV__ && appConfig && appConfig.serverContextPath != null) {
    __webpack_public_path__ = `${appConfig.serverContextPath}/res/`;
}
